
/**
 * RecipeObserver is responsible for adding "is-pinned" class to the recipe detail section headers so that we can style them differently
 * when the header is sticking to the top of the page on mobile devices.
 */
var recipeObserver = function recipeObserver(config) {
  var external = {};
  var internal = {};
  config = config || {};
  internal.config = {
    testMode: !!config.testMode
  };

  if (config.testMode === true) {
    external.internal = internal;
  }
  /**
   * @function initialize
   * Initializes variables such as the target elements to observer.
   * Also sets the observer options and class the functions to create the observers.
   */


  external.initialize = function () {
    var smallScreenSize = 766;
    if (internal.getWindowInnerWidth() >= smallScreenSize) return;
    var recipeHeaderClasses = [".redesign .recipeIngredients h2", ".redesign .recipeIngredients .recipeBuyNow", ".redesign .tipCategoryHeading", ".redesign .recipeSteps .stepsTop", ".redesign .recipeNutrition .nutritionTop"];
    var options = {
      root: null,
      threshold: [0, 0.05, 1]
    };
    var observer = new window.IntersectionObserver(internal.handleRdpHeaderIntersectionEvent, options);
    recipeHeaderClasses.forEach(function (headerClass) {
      var element = document.querySelector(headerClass);
      if (!element) return;
      observer.observe(element);
    });
  };

  internal.handleRdpHeaderIntersectionEvent = function (intersectionEntries) {
    intersectionEntries.forEach(function (entry) {
      var target = entry.target;
      var targetInfo = entry.boundingClientRect;

      if (targetInfo.top < 0) {
        target.classList.add("is-pinned");
      } else if (targetInfo.top > 0) {
        target.classList.remove("is-pinned");
      }
    });
  };

  internal.getWindowInnerWidth = function () {
    return window.innerWidth;
  };

  external.initialize();
  return external;
};

export default recipeObserver;